/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from 'react';
import { useApi } from 'shared_components/context';
import { useClientId } from 'shared_components/context/client';
import { PipelineRunStatusStatusEnum } from 'shared_components/generated/admin';
import WModal from 'shared_components/components/WModal';
import { ArtistDiscographyIDSearch } from './ArtistDiscographyIDSearch';
import { ArtistDiscographyIDContent } from './ArtistDiscographyIDContent';
import { DiscographyIdsProvider } from './useDiscographyIds';
import { PrimaryDiscographyRunProvider } from './usePrimaryDiscographyRun';

interface ArtistDiscographyIDCardProps {
  isOpen: boolean;
  onClose: () => void;
  onComplete?: () => void;
  onUserSettingsUpdated?: () => void;
}

function ArtistDiscographyIDCardImplementation({
  isOpen,
  onClose,
  onComplete,
  onUserSettingsUpdated,
}: ArtistDiscographyIDCardProps) {
  const { adminApi: api } = useApi();

  const { clientId } = useClientId();
  const [runStatus, setRunStatus] =
    useState<PipelineRunStatusStatusEnum | null>(null);

  const getDiscographyPipelineRunStatus = async () => {
    if (clientId === undefined) {
      return;
    }
    if (!isOpen) {
      return;
    }
    await api
      .retrievePipelineRunStatus({ userId: clientId })
      .then(({ status }) => setRunStatus(status))
      .catch(() => setRunStatus(null));
  };

  useEffect(() => {
    getDiscographyPipelineRunStatus();
  }, [isOpen, clientId]);

  const handleClose = () => {
    if (runStatus === PipelineRunStatusStatusEnum.Success) {
      onComplete && onComplete();
      onClose();
      return;
    }
    onClose();
  };

  const [searchVisible, setSearchVisible] = useState(false);

  return (
    <WModal
      title=""
      isOpen={isOpen}
      onClose={handleClose}
      modalClasses="tw-w-[90%]"
    >
      <div
        className="tw-rounded-xl tw-shadow-2xl tw-w-full tw-h-[90vh] tw-flex tw-overflow-hidden tw-z-20"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Search Panel - Collapsible */}
        {searchVisible ? <ArtistDiscographyIDSearch /> : null}
        {/* Sidebar content */}
        <ArtistDiscographyIDContent
          toggleSearchPanel={() => setSearchVisible((state) => !state)}
          isSearchExpanded={searchVisible}
          onUserSettingsUpdated={() => onUserSettingsUpdated?.()}
        />
      </div>
    </WModal>
  );
}

export default function ArtistDiscographyIDCard(
  props: ArtistDiscographyIDCardProps
) {
  return (
    <PrimaryDiscographyRunProvider>
      <DiscographyIdsProvider>
        <ArtistDiscographyIDCardImplementation {...props} />
      </DiscographyIdsProvider>
    </PrimaryDiscographyRunProvider>
  );
}
